import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-bottom: 56px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LoaderContentWrapper = styled.div`
  margin-top: 128px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
`

export const LoaderText = styled.p`
  color: #603363;
  text-align: center;
  font-size: 18px;
  font-family: Inter;
  line-height: 26px;
`

export const GridTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
